import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { FeatureFlag } from '../common/featureFlags';
import { FeatureFlagsFacadeService } from '../services/feature-flags-facade.service';

export function featureFlagGuard(featureFlag: FeatureFlag): CanMatchFn {
  return () => {
    const featureFlagsFacade = inject(FeatureFlagsFacadeService);
    const enabled = featureFlagsFacade.featureFlagEnabled(featureFlag);
    return enabled;
  };
}
